// Shared upgrade costs per level (jewels and essence needed to reach that level)
// null means cost data not available in source
export const levelCosts = [
  { level: 1, jewels: 10, essence: 0 },
  { level: 2, jewels: 15, essence: 0 },
  { level: 3, jewels: 20, essence: 0 },
  { level: 4, jewels: 25, essence: 0 },
  { level: 5, jewels: 30, essence: 0 },
  { level: 6, jewels: 35, essence: 0 },
  { level: 7, jewels: 40, essence: 0 },
  { level: 8, jewels: 45, essence: 0 },
  { level: 9, jewels: 50, essence: 0 },
  { level: 10, jewels: 55, essence: 0 },
  { level: 11, jewels: 61, essence: 0 },
  { level: 12, jewels: 67, essence: 0 },
  { level: 13, jewels: 73, essence: 0 },
  { level: 14, jewels: 79, essence: 0 },
  { level: 15, jewels: 85, essence: 0 },
  { level: 16, jewels: 91, essence: 0 },
  { level: 17, jewels: 97, essence: 0 },
  { level: 18, jewels: 103, essence: 0 },
  { level: 19, jewels: 109, essence: 0 },
  { level: 20, jewels: 115, essence: 0 },
  { level: 21, jewels: 118, essence: 9 },
  { level: 22, jewels: 121, essence: 13 },
  { level: 23, jewels: 124, essence: 16 },
  { level: 24, jewels: 127, essence: 19 },
  { level: 25, jewels: 130, essence: 22 },
  { level: 26, jewels: 133, essence: 25 },
  { level: 27, jewels: 136, essence: 28 },
  { level: 28, jewels: 139, essence: 31 },
  { level: 29, jewels: 142, essence: 34 },
  { level: 30, jewels: 146, essence: 37 },
  { level: 31, jewels: 196, essence: 47 },
  { level: 32, jewels: 246, essence: 57 },
  { level: 33, jewels: 296, essence: 67 },
  { level: 34, jewels: 346, essence: 77 },
  { level: 35, jewels: 396, essence: 87 },
  { level: 36, jewels: 446, essence: 97 },
  { level: 37, jewels: 496, essence: 107 },
  { level: 38, jewels: 546, essence: 117 },
  { level: 39, jewels: 596, essence: 127 },
  { level: 40, jewels: 646, essence: 137 }
]

// Ruby stats per level: Increase attack of backline (%), Backline penetration, Reduce dmg taken from backline (%)
const rubyLevels = [
  { level: 1, stat1: 1.5, stat2: 0, stat3: 0 },
  { level: 2, stat1: 3, stat2: 0, stat3: 0 },
  { level: 3, stat1: 4.5, stat2: 0, stat3: 0 },
  { level: 4, stat1: 6, stat2: 0, stat3: 0 },
  { level: 5, stat1: 7.5, stat2: 0, stat3: 0 },
  { level: 6, stat1: 9, stat2: 0, stat3: 0 },
  { level: 7, stat1: 10.5, stat2: 0, stat3: 0 },
  { level: 8, stat1: 12, stat2: 0, stat3: 0 },
  { level: 9, stat1: 13.5, stat2: 0, stat3: 0 },
  { level: 10, stat1: 15, stat2: 0, stat3: 0 },
  { level: 11, stat1: 15.2, stat2: 5, stat3: 0 },
  { level: 12, stat1: 15.4, stat2: 10, stat3: 0 },
  { level: 13, stat1: 15.6, stat2: 15, stat3: 0 },
  { level: 14, stat1: 15.8, stat2: 20, stat3: 0 },
  { level: 15, stat1: 16, stat2: 25, stat3: 0 },
  { level: 16, stat1: 16.2, stat2: 30, stat3: 0 },
  { level: 17, stat1: 16.4, stat2: 35, stat3: 0 },
  { level: 18, stat1: 16.6, stat2: 40, stat3: 0 },
  { level: 19, stat1: 16.8, stat2: 45, stat3: 0 },
  { level: 20, stat1: 17, stat2: 50, stat3: 0 },
  { level: 21, stat1: 17.2, stat2: 51, stat3: 0.3 },
  { level: 22, stat1: 17.4, stat2: 52, stat3: 0.6 },
  { level: 23, stat1: 17.6, stat2: 53, stat3: 0.9 },
  { level: 24, stat1: 17.8, stat2: 54, stat3: 1.2 },
  { level: 25, stat1: 18, stat2: 55, stat3: 1.5 },
  { level: 26, stat1: 18.2, stat2: 56, stat3: 1.8 },
  { level: 27, stat1: 18.4, stat2: 57, stat3: 2.1 },
  { level: 28, stat1: 18.6, stat2: 58, stat3: 2.4 },
  { level: 29, stat1: 18.8, stat2: 59, stat3: 2.7 },
  { level: 30, stat1: 19, stat2: 60, stat3: 3 },
  { level: 31, stat1: 19.2, stat2: 61, stat3: 3.3 },
  { level: 32, stat1: 19.4, stat2: 62, stat3: 3.6 },
  { level: 33, stat1: 19.6, stat2: 63, stat3: 3.9 },
  { level: 34, stat1: 19.8, stat2: 64, stat3: 4.2 },
  { level: 35, stat1: 20, stat2: 65, stat3: 4.5 },
  { level: 36, stat1: 20.2, stat2: 66, stat3: 4.8 },
  { level: 37, stat1: 20.4, stat2: 67, stat3: 5.1 },
  { level: 38, stat1: 20.6, stat2: 68, stat3: 5.4 },
  { level: 39, stat1: 20.8, stat2: 69, stat3: 5.7 },
  { level: 40, stat1: 21, stat2: 70, stat3: 6 }
]

// Sapphire stats per level: Frontline HP (%), Backline Mastery, Troops dmg taken reduction (%)
const sapphireLevels = [
  { level: 1, stat1: 1.5, stat2: 0, stat3: 0 },
  { level: 2, stat1: 3, stat2: 0, stat3: 0 },
  { level: 3, stat1: 4.5, stat2: 0, stat3: 0 },
  { level: 4, stat1: 6, stat2: 0, stat3: 0 },
  { level: 5, stat1: 7.5, stat2: 0, stat3: 0 },
  { level: 6, stat1: 9, stat2: 0, stat3: 0 },
  { level: 7, stat1: 10.5, stat2: 0, stat3: 0 },
  { level: 8, stat1: 12, stat2: 0, stat3: 0 },
  { level: 9, stat1: 13.5, stat2: 0, stat3: 0 },
  { level: 10, stat1: 15, stat2: 0, stat3: 0 },
  { level: 11, stat1: 15.2, stat2: 5, stat3: 0 },
  { level: 12, stat1: 15.4, stat2: 10, stat3: 0 },
  { level: 13, stat1: 15.6, stat2: 15, stat3: 0 },
  { level: 14, stat1: 15.8, stat2: 20, stat3: 0 },
  { level: 15, stat1: 16, stat2: 25, stat3: 0 },
  { level: 16, stat1: 16.2, stat2: 30, stat3: 0 },
  { level: 17, stat1: 16.4, stat2: 35, stat3: 0 },
  { level: 18, stat1: 16.6, stat2: 40, stat3: 0 },
  { level: 19, stat1: 16.8, stat2: 45, stat3: 0 },
  { level: 20, stat1: 17, stat2: 50, stat3: 0 },
  { level: 21, stat1: 17.2, stat2: 51, stat3: 0.2 },
  { level: 22, stat1: 17.4, stat2: 52, stat3: 0.4 },
  { level: 23, stat1: 17.6, stat2: 53, stat3: 0.6 },
  { level: 24, stat1: 17.8, stat2: 54, stat3: 0.8 },
  { level: 25, stat1: 18, stat2: 55, stat3: 1 },
  { level: 26, stat1: 18.2, stat2: 56, stat3: 1.2 },
  { level: 27, stat1: 18.4, stat2: 57, stat3: 1.4 },
  { level: 28, stat1: 18.6, stat2: 58, stat3: 1.6 },
  { level: 29, stat1: 18.8, stat2: 59, stat3: 1.8 },
  { level: 30, stat1: 19, stat2: 60, stat3: 2 },
  { level: 31, stat1: 19.2, stat2: 61, stat3: 2.2 },
  { level: 32, stat1: 19.4, stat2: 62, stat3: 2.4 },
  { level: 33, stat1: 19.6, stat2: 63, stat3: 2.6 },
  { level: 34, stat1: 19.8, stat2: 64, stat3: 2.8 },
  { level: 35, stat1: 20, stat2: 65, stat3: 3 },
  { level: 36, stat1: 20.2, stat2: 66, stat3: 3.2 },
  { level: 37, stat1: 20.4, stat2: 67, stat3: 3.4 },
  { level: 38, stat1: 20.6, stat2: 68, stat3: 3.6 },
  { level: 39, stat1: 20.8, stat2: 69, stat3: 3.8 },
  { level: 40, stat1: 21, stat2: 70, stat3: 4 }
]

// Topaz stats per level: Enemy attack reduction (%), Frontline Resilience, Damage against frontline (%)
const topazLevels = [
  { level: 1, stat1: 0.8, stat2: 0, stat3: 0 },
  { level: 2, stat1: 1.6, stat2: 0, stat3: 0 },
  { level: 3, stat1: 2.4, stat2: 0, stat3: 0 },
  { level: 4, stat1: 3.2, stat2: 0, stat3: 0 },
  { level: 5, stat1: 4, stat2: 0, stat3: 0 },
  { level: 6, stat1: 4.8, stat2: 0, stat3: 0 },
  { level: 7, stat1: 5.6, stat2: 0, stat3: 0 },
  { level: 8, stat1: 6.4, stat2: 0, stat3: 0 },
  { level: 9, stat1: 7.2, stat2: 0, stat3: 0 },
  { level: 10, stat1: 8, stat2: 0, stat3: 0 },
  { level: 11, stat1: 8.1, stat2: 5, stat3: 0 },
  { level: 12, stat1: 8.2, stat2: 10, stat3: 0 },
  { level: 13, stat1: 8.3, stat2: 15, stat3: 0 },
  { level: 14, stat1: 8.4, stat2: 20, stat3: 0 },
  { level: 15, stat1: 8.5, stat2: 25, stat3: 0 },
  { level: 16, stat1: 8.6, stat2: 30, stat3: 0 },
  { level: 17, stat1: 8.7, stat2: 35, stat3: 0 },
  { level: 18, stat1: 8.8, stat2: 40, stat3: 0 },
  { level: 19, stat1: 8.9, stat2: 45, stat3: 0 },
  { level: 20, stat1: 9, stat2: 50, stat3: 0 },
  { level: 21, stat1: 9.1, stat2: 51, stat3: 0.3 },
  { level: 22, stat1: 9.2, stat2: 52, stat3: 0.6 },
  { level: 23, stat1: 9.3, stat2: 53, stat3: 0.9 },
  { level: 24, stat1: 9.4, stat2: 54, stat3: 1.2 },
  { level: 25, stat1: 9.5, stat2: 55, stat3: 1.5 },
  { level: 26, stat1: 9.6, stat2: 56, stat3: 1.8 },
  { level: 27, stat1: 9.7, stat2: 57, stat3: 2.1 },
  { level: 28, stat1: 9.8, stat2: 58, stat3: 2.4 },
  { level: 29, stat1: 9.9, stat2: 59, stat3: 2.7 },
  { level: 30, stat1: 10, stat2: 60, stat3: 3 },
  { level: 31, stat1: 10.1, stat2: 61, stat3: 3.3 },
  { level: 32, stat1: 10.2, stat2: 62, stat3: 3.6 },
  { level: 33, stat1: 10.3, stat2: 63, stat3: 3.9 },
  { level: 34, stat1: 10.4, stat2: 64, stat3: 4.2 },
  { level: 35, stat1: 10.5, stat2: 65, stat3: 4.5 },
  { level: 36, stat1: 10.6, stat2: 66, stat3: 4.8 },
  { level: 37, stat1: 10.7, stat2: 67, stat3: 5.1 },
  { level: 38, stat1: 10.8, stat2: 68, stat3: 5.4 },
  { level: 39, stat1: 10.9, stat2: 69, stat3: 5.7 },
  { level: 40, stat1: 11, stat2: 70, stat3: 6 }
]

// Stat info notes
const statNotes = {
  backlinePenetration: 'Archer and mage penetration (0.3% dmg per point, 60 = 18%)',
  backlineMastery: 'Archer and mage mastery (0.3% dmg per point, 60 = 18%)',
  frontlineResilience: 'Infantry and cavalry resilience (0.3% dmg per point, 60 = 18%)'
}

export const jewelsData = [
  {
    id: 1,
    name: 'Ruby',
    equipment: 'Weapon',
    type: 'ruby',
    color: '#E53935',
    image: '/images/jewels/jewel-red.webp',
    statNames: ['Increase attack of backline (%)', 'Backline penetration', 'Reduce dmg taken from backline (%)'],
    statNotes: [null, statNotes.backlinePenetration, null],
    levels: rubyLevels
  },
  {
    id: 2,
    name: 'Ruby',
    equipment: 'Helmet',
    type: 'ruby',
    color: '#E53935',
    image: '/images/jewels/jewel-red.webp',
    statNames: ['Increase attack of backline (%)', 'Backline penetration', 'Reduce dmg taken from backline (%)'],
    statNotes: [null, statNotes.backlinePenetration, null],
    levels: rubyLevels
  },
  {
    id: 3,
    name: 'Sapphire',
    equipment: 'Belt',
    type: 'sapphire',
    color: '#1E88E5',
    image: '/images/jewels/jewel-blue.webp',
    statNames: ['Frontline HP (%)', 'Backline Mastery', 'Troops dmg taken reduction (%)'],
    statNotes: [null, statNotes.backlineMastery, null],
    levels: sapphireLevels
  },
  {
    id: 4,
    name: 'Sapphire',
    equipment: 'Clothes',
    type: 'sapphire',
    color: '#1E88E5',
    image: '/images/jewels/jewel-blue.webp',
    statNames: ['Frontline HP (%)', 'Backline Mastery', 'Troops dmg taken reduction (%)'],
    statNotes: [null, statNotes.backlineMastery, null],
    levels: sapphireLevels
  },
  {
    id: 5,
    name: 'Topaz',
    equipment: 'Accessory',
    type: 'topaz',
    color: '#FDD835',
    image: '/images/jewels/jewel-yellow.webp',
    statNames: ['Enemy attack reduction (%)', 'Frontline Resilience', 'Damage against frontline (%)'],
    statNotes: [null, statNotes.frontlineResilience, null],
    levels: topazLevels
  },
  {
    id: 6,
    name: 'Topaz',
    equipment: 'Boots',
    type: 'topaz',
    color: '#FDD835',
    image: '/images/jewels/jewel-yellow.webp',
    statNames: ['Enemy attack reduction (%)', 'Frontline Resilience', 'Damage against frontline (%)'],
    statNotes: [null, statNotes.frontlineResilience, null],
    levels: topazLevels
  }
]

export default jewelsData
